import React from 'react'
import { AppRetailerBlockContainer } from "@components/DataBlocks"
import { Box } from "@mui/material"


export default function sitesColumn() {

	return [{
		name: "sitesNameFilter", label: "Sites",
		options: { display: 'excluded' }
	}, {
		name: 'sitesName',
		label: 'Sites',
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<AppRetailerBlockContainer rows={value}/>
			</Box>,
		}
	}]
}